import Scrollbar from '@/_application/core/components/ui/scrollbar';
import ProductAttribute from '@/_application/modules/products/components/attributes/product.attribute';
import {generateVariations} from '@/store/attributes/attributes.utils';
import React from 'react';
import {ConfigurableProductOptions, ConfigurableProductOptionsValues, Maybe} from '@/__generated__/__types__';
import {useAttributes} from '@/store/attributes/attributes.context';

interface Props {
    productOptions: Maybe<ConfigurableProductOptions>[];
    emitSelectOptionAction?: () => void;
}

const VariationGroups: React.FC<Props> = ({productOptions, emitSelectOptionAction}) => {
    const {attributes, disabledAttributes, handleSelectAttribute} = useAttributes();
    const replaceHyphens = (str: string) => {
        return str.replace(/-/g, ' ');
    };

    const variations = generateVariations(productOptions);

    const handleSelected = (variationCode: string, value: ConfigurableProductOptionsValues) => {
        handleSelectAttribute(variationCode, value);
        emitSelectOptionAction && emitSelectOptionAction();
    };

    return (
        <>
            {Object.keys(variations).map(variationCode => (
                <div
                    className="mb-4 bg-white pb-3 pl-4 pt-2 md:mb-0 md:border-b md:pb-1.5 md:pl-0 md:pt-0.5"
                    key={variationCode}>
                    <span className="mb-2 inline-block whitespace-nowrap text-sm font-bold text-primary">
                        {replaceHyphens(variations[variationCode].label ?? '')}
                    </span>
                    <div className="w-full overflow-hidden">
                        <Scrollbar
                            className="w-full"
                            options={{
                                scrollbars: {
                                    autoHide: 'never',
                                },
                            }}>
                            <div className="flex w-full flex-wrap gap-2">
                                {variations[variationCode].values?.map(value => {
                                    if (!value?.value_index) return <></>;
                                    const isOptionDisabled =
                                        disabledAttributes[variationCode]?.has(value.value_index) ?? false;
                                    const selectedOption = attributes[variationCode]?.value_index ?? 0;
                                    return (
                                        <ProductAttribute
                                            key={value.value_index}
                                            attribute={{
                                                code: variationCode,
                                                label: value?.label,
                                                value_index: value?.value_index,
                                            }}
                                            isDisabled={isOptionDisabled}
                                            currentOption={selectedOption}
                                            onSelected={() => handleSelected(variationCode, value)}
                                        />
                                    );
                                })}
                            </div>
                        </Scrollbar>
                    </div>
                </div>
            ))}
        </>
    );
};

export default VariationGroups;
